import _ from 'lodash';
import { translationDictionary } from './SlugParser';

// per saber si hem de fer una url friendly (server) o amb querystring (static/export)
const _routePathType = {
    web: ''
};

const _routePathJitPub1 = {
    web_esports: 'https://www.3cat.cat/esport3/'
};

const _routePathJitPub2 = {
    web_butlletins_gestio: '/butlletins/',
    web_butlletins_item_butlleti: '/butlletins/{slug}/{id}/',
    web_transparencia_home: '/corporatiu/transparencia/',
    web_transparencia_seccio: '/corporatiu/transparencia/{slug}',
    web_transparencia_item_document: '/corporatiu/transparencia/{slug}/document/{id}/',
    web_transparencia_cerca: '/corporatiu/transparencia/resultats-cerca/?text={slug}',
    web_actualitat_item_noticia: '/3catinfo/{slug}/noticia/{id}/',
    web_actualitat_item_noticia_amp: '/3catinfo/{slug}/noticia-amp/{id}/'
};

const _routePaths = { ..._routePathJitPub1, ..._routePathJitPub2 };

const _getSlug = (cadena) => {
    let replaced;
    const translationDictionaryRegex = RegExp('[' + _.keys(translationDictionary).join('') + ']', 'gi');
    replaced = cadena.replace(translationDictionaryRegex, function (m) {
        let ret = translationDictionary[m.toUpperCase()];
        if (m === m.toLowerCase()) ret = ret.toLowerCase();
        return ret;
    });

    return replaced
        .replace(/[^a-zA-Z0-9\-_<>]/gi, '')
        .replace(/[\-]+/gi, '-')
        .replace(/<[^>]*>/gi, '')
        .replace(/^[-]/gi, '')
        .replace(/[-]$/gi, '')
        .toLowerCase();
};

/**
 * id: id del contingut
 * slug: titol del contingut, escapat en-format-url
 * slug2: titol del contingut, escapat en-format-url
 * params: titol del contingut, escapat en-format-url
 * routePath: força emprar el patró de friendly indicat explícitament
 **/

const getUrlFriendly = (props) => {
    let { id, slug, slug2, params, routePath } = props;
    try {
        slug = slug ? _getSlug(slug) : 'titol';
        slug2 = slug2 ? _getSlug(slug2) : 'titol';
        routePath = _routePaths[routePath]
            .replace('{id}', id)
            .replace('{slug}', slug)
            .replace('{slug2}', slug2)
            .replace('{params}', params);
        return routePath;
    } catch (error) {
        console.log('Error Routeresolver', error);
        return '#';
    }
};

const getUrlCanonical = (props) => {
    const { id, routePath } = props;
    let { slug } = props;
    slug = slug ? _getSlug(slug) : 'titol';
    return _routePaths[routePath].replace('{id}', id).replace('{slug}', slug);
};

const getRouteType = (url) => {
    if (!url) return {};

    const convertToRegex = (pattern) => {
        return new RegExp('^' + pattern.replace(/{(\w+)}/g, '(?<$1>[^/]+)') + '$');
    };

    for (const [type, pattern] of Object.entries(_routePaths)) {
        const regexPattern = convertToRegex(pattern);
        const match = url.match(regexPattern);
        if (match) {
            return {
                type,
                ...match.groups
            };
        }
    }

    return {};
};

export { getRouteType, getUrlCanonical, getUrlFriendly };
